import React, { useState, useEffect } from "react";

const ToggleSwitch = ({ checked, onChange }) => (
  <div className={`toggle-switch ${checked ? "active" : ""}`} onClick={() => onChange(!checked)}>
    <div className="toggle-switch-slider"></div>
  </div>
);

const FeedSettings = ({ settings, onUpdate }) => {
  const [localSettings, setLocalSettings] = useState(settings || {});

  useEffect(() => {
    setLocalSettings(settings || {});
  }, [settings]);

  const handleUpdate = async (key, value) => {
    const updated = { ...localSettings, [key]: value };
    setLocalSettings(updated);
    try {
      await onUpdate(updated);
    } catch (error) {
      setLocalSettings(localSettings);
    }
  };

  return (
    <div>
      <div className="settings-header">
        <h1>Preferências de Feed</h1>
        <p>Personalize como você vê o conteúdo no seu feed</p>
      </div>

      <div className="settings-section">
        <h3 className="settings-section-title">📰 Tipo de Feed</h3>

        <div className="settings-item">
          <div className="settings-item-info">
            <div className="settings-item-label">Feed padrão</div>
            <div className="settings-item-description">
              Escolha qual feed você quer ver ao abrir a plataforma
            </div>
          </div>
          <div className="settings-item-control">
            <select
              className="settings-select"
              value={localSettings.defaultFeedType || "timeline"}
              onChange={(e) => handleUpdate("defaultFeedType", e.target.value)}
            >
              <option value="timeline">Linha do Tempo</option>
              <option value="trending">Em Alta</option>
              <option value="following">Seguindo</option>
              <option value="discover">Descobrir</option>
            </select>
          </div>
        </div>

        <div className="settings-item">
          <div className="settings-item-info">
            <div className="settings-item-label">Feed cronológico</div>
            <div className="settings-item-description">
              Mostrar posts em ordem de publicação ao invés de algoritmo
            </div>
          </div>
          <div className="settings-item-control">
            <ToggleSwitch
              checked={localSettings.chronologicalFeed === true}
              onChange={(val) => handleUpdate("chronologicalFeed", val)}
            />
          </div>
        </div>
      </div>

      <div className="settings-section">
        <h3 className="settings-section-title">📺 Conteúdo do Feed</h3>

        <div className="settings-item">
          <div className="settings-item-info">
            <div className="settings-item-label">Mostrar stories</div>
          </div>
          <div className="settings-item-control">
            <ToggleSwitch
              checked={localSettings.showStories !== false}
              onChange={(val) => handleUpdate("showStories", val)}
            />
          </div>
        </div>

        <div className="settings-item">
          <div className="settings-item-info">
            <div className="settings-item-label">Mostrar reels</div>
          </div>
          <div className="settings-item-control">
            <ToggleSwitch
              checked={localSettings.showReels !== false}
              onChange={(val) => handleUpdate("showReels", val)}
            />
          </div>
        </div>

        <div className="settings-item">
          <div className="settings-item-info">
            <div className="settings-item-label">Mostrar recomendações</div>
            <div className="settings-item-description">
              Exibir conteúdo sugerido baseado nos seus interesses
            </div>
          </div>
          <div className="settings-item-control">
            <ToggleSwitch
              checked={localSettings.showRecommendations !== false}
              onChange={(val) => handleUpdate("showRecommendations", val)}
            />
          </div>
        </div>
      </div>

      <div className="settings-info-card">
        <div className="settings-info-card-title">💡 Sobre o Feed</div>
        <div className="settings-info-card-text">
          O algoritmo do feed é projetado para mostrar o conteúdo mais relevante
          para você. Use estas configurações para personalizar sua experiência.
        </div>
      </div>
    </div>
  );
};

export default FeedSettings;
